import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css';
import { PatientCareCenterNoteGoalsGoalShortTermGoalDetail } from './ShortTermGoalDetail'
import { PatientCareCenterNoteGoalsGoalShortTermGoalDetailCustom } from './ShortTermGoalDetailCustom'
import { bindActionCreators } from 'redux';
import { AddButton } from '_components';
import { noteActions } from '_actions';

class PatientCareCenterNoteGoalsGoalShortTermGoals extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: '-1',
        }
        this.onChange = this.onChange.bind(this)
    };

    async onChange(event) {
        await this.setState({ selectedDate: event.target.value });
        //update all dates
        this.props.updateDatesSTG(this.props.noteId, event.target.value);

        // let value = '';
        // let date = new Date();
        // value = date.setTime(date.getTime() + event.target.value * 86400000);
        // Object.keys(this.props.stg)
        //     .forEach(x => {
        //         this.props.updateDateField(this.props.noteId, 'PTSHORTGOALS', 'SGNO', this.props.stg[x].SGNO, 'SGDATE', value);
        //     });

        // Object.keys(this.props.stg_custom)
        //     .forEach(x => {
        //         this.props.updateDateField(this.props.noteId, 'PTSHORTGOALS', 'SGNO', this.props.stg_custom[x].SGNO, 'SGDATE', value);
        //     });

        // this.props.setStgDateDefault({ noteId: this.props.noteId, stgDateDefault: event.target.value === '0' ? undefined : date.toISOString().split('T')[0] });
    }

    addCustomGoal() {
        if (this.state.selectedDate !== '-1' && this.state.selectedDate !== '0') {
            var goalDate = new Date();
            goalDate.setDate(goalDate.getDate() + parseInt(this.state.selectedDate));
            this.props.addCustomSTGoal(this.props.noteId, goalDate.toISOString().split('T')[0]);
        } else {
            this.props.addCustomSTGoal(this.props.noteId);
        }
        if (!this.props.goalsUpdated && this.props.noteType !== 1) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }


    render() {

        let options = [
            { id: '7', value: '1 Week', days: 7 },
            { id: '14', value: '2 Week', days: 14 },
            { id: '21', value: '3 Week', days: 21 },
            { id: '28', value: '4 Week', days: 28 },
            { id: '35', value: '5 Week', days: 35 },
            { id: '42', value: '6 Week', days: 42 },
            { id: '49', value: '7 Week', days: 49 },
            { id: '56', value: '8 Week', days: 56 },
            { id: '90', value: '3 Months', days: 90 },
            { id: '120', value: '4 Months', days: 120 },
            { id: '150', value: '5 Months', days: 150 },
            { id: '180', value: '6 Months', days: 180 },
            { id: '210', value: '7 Months', days: 210 },
            { id: '230', value: '8 Months', days: 230 }
        ];

        return (
            <div className={styles.stg_header_wrapper}>
                <div className={styles.stg_header_row}>
                    <div className={styles.stg_header_1}>Short Term Goals</div>
                    {this.props.noteType !== 2 && this.props.noteType !== 4 && this.props.noteType !== 6 &&
                        <>
                            <div className={styles.stg_header_2}>Default all dates to:</div>
                            <div className={styles.stg_header_3}>
                                <select className={styles.stg_default_dropdown} value={this.state.selectedDate} onChange={(event) => this.onChange(event)}>

                                    <option key={0} value={0}></option>
                                    {Object.keys(options)
                                        .map(id => {
                                            const option = options[id];
                                            return (
                                                <option key={option.id} value={option.id} days={option.days}>{option.value}</option>
                                            );
                                        })
                                    }
                                </select>
                            </div>
                            {this.props.noteType !== 1 &&
                                <>
                                    <span className={styles.goal_detail_prog_dropdown_stg}>
                                    </span>
                                    {this.props.noteType !== 2 &&
                                        <div className={styles.goal_detail_copy_col}>
                                        </div>
                                    }

                                </>
                            }
                        </>
                    }
                </div>
                <div className={styles.stg_detailrow}>
                    {Object.keys(this.props.stg)
                        .map(key => {
                            const result = this.props.stg[key];
                            return (
                                <PatientCareCenterNoteGoalsGoalShortTermGoalDetail id={result.SGNO} key={result.SGNO} days={this.props.selectedDate} />
                            )
                        })
                    }
                </div>
                {(this.props.noteType === 1 || this.props.noteType === 3 || this.props.noteType === 5) &&
                    <div className={styles.stg_detailrow}>
                        <span className={styles.add_button_wrapper}>
                            <AddButton size='extra-small' title={'Add Custom Short Term Goal'} onClick={() => this.addCustomGoal()} />
                        </span>
                        <div className={styles.stg_header_1}>Custom Short Term Goals</div>
                    </div>
                }
                {Object.keys(this.props.stg_custom)
                    .map(key => {
                        const result = this.props.stg_custom[key];
                        return (
                            <PatientCareCenterNoteGoalsGoalShortTermGoalDetailCustom id={result.SGNO} key={result.SGNO} />
                        )
                    })
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        addCustomSTGoal: bindActionCreators(noteActions.addCustomSTGoal, dispatch),
        updateDateField: bindActionCreators(noteActions.updateDateField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        setStgDateDefault: bindActionCreators(noteActions.setStgDateDefault, dispatch),
        updateDatesSTG: bindActionCreators(noteActions.updateDatesSTG, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stg = Object.keys(state.entities.notes.PTSHORTGOALS)
        .filter(key => {
            return (state.entities.notes.PTSHORTGOALS[key].NoteId === noteId && !state.entities.notes.PTSHORTGOALS[key].SGCUSTOM);
        })
        .sort((a, b) => { return state.entities.notes.PTSHORTGOALS[a].SGNO - state.entities.notes.PTSHORTGOALS[b].SGNO; })
        .map(key => state.entities.notes.PTSHORTGOALS[key]);


    let stg_custom = Object.keys(state.entities.notes.PTSHORTGOALS)
        .filter(key => {
            return (state.entities.notes.PTSHORTGOALS[key].NoteId === noteId && state.entities.notes.PTSHORTGOALS[key].SGCUSTOM && state.entities.notes.PTSHORTGOALS[key].SGACTIVE);
        })
        .sort((a, b) => { return state.entities.notes.PTSHORTGOALS[a].SGNO - state.entities.notes.PTSHORTGOALS[b].SGNO; })
        .map(key => state.entities.notes.PTSHORTGOALS[key]);

    return {
        noteId,
        noteType,
        pk,
        stg,
        stg_custom,
    };
}

const connectedPatientCareCenterNoteGoalsGoalShortTermGoals = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsGoalShortTermGoals);
export { connectedPatientCareCenterNoteGoalsGoalShortTermGoals as PatientCareCenterNoteGoalsGoalShortTermGoals };

